import blogPosts from "../data/blogPosts";

function calculateScore(
  currentPost,
  targetPost
) {
  let score = 0;

  // Same category boost
  if (
    currentPost.category ===
    targetPost.category
  ) {
    score += 5;
  }

  // Shared tags boost
  const sharedTags =
    targetPost.tags?.filter((tag) =>
      currentPost.tags?.includes(tag)
    ) || [];

  score += sharedTags.length * 3;

  // Shared keywords boost
  const sharedKeywords =
    targetPost.keywords?.filter(
      (keyword) =>
        currentPost.keywords?.includes(
          keyword
        )
    ) || [];

  score +=
    sharedKeywords.length * 2;

  // Featured boost
  if (targetPost.featured) {
    score += 1;
  }

  return score;
}

export default function getRelatedPosts(
  currentSlug,
  limit = 3
) {
  const currentPost =
    blogPosts.find(
      (post) =>
        post.slug === currentSlug
    );

  if (!currentPost) {
    return [];
  }

  return blogPosts
    .filter(
      (post) =>
        post.slug !== currentSlug
    )
    .map((post) => ({
      ...post,
      score: calculateScore(
        currentPost,
        post
      )
    }))
    .sort(
      (a, b) => b.score - a.score
    )
    .slice(0, limit);
}